module.exports = __webpack_public_path__ + "1ce1b5bd5e498a279f50296eeb94a813.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/thaipbs.png
// module id = 1381
// module chunks = 47